export const recentPurchases = [
  { name: 'Emily R.', city: 'Austin', country: 'United States', time: '2 minutes ago' },
  { name: 'Lucas M.', city: 'Madrid', country: 'Spain', time: '5 minutes ago' },
  { name: 'Sofía G.', city: 'Córdoba', country: 'Argentina', time: '8 minutes ago' },
  { name: 'Chloe B.', city: 'Melbourne', country: 'Australia', time: '11 minutes ago' },
  { name: 'Daniel K.', city: 'Toronto', country: 'Canada', time: '14 minutes ago' },
  { name: 'Valentina P.', city: 'Mexico City', country: 'Mexico', time: '18 minutes ago' },
  { name: 'Hannah S.', city: 'Berlin', country: 'Germany', time: '23 minutes ago' },
  { name: 'Mateus O.', city: 'São Paulo', country: 'Brazil', time: '27 minutes ago' },
  { name: 'Olivia T.', city: 'London', country: 'United Kingdom', time: '31 minutes ago' },
  { name: 'Camila R.', city: 'Santiago', country: 'Chile', time: '36 minutes ago' },
]
